export default __webpack_public_path__ + "static/media/explosion.aee262ac.png";